import { h } from 'preact';
import { useContext, useMemo } from 'preact/hooks';
import { ItemsContext } from './ItemsProvider';

const BundleDescription = () => {
  const {
    state: { bundle },
  } = useContext(ItemsContext);

  return (
    <div className="shopify-product-details__short-description">
      <div
        className="short-description"
        dangerouslySetInnerHTML={{ __html: bundle.product.description }}
      ></div>
    </div>
  );
};

export default BundleDescription;
